module.exports = __webpack_public_path__ + "img/goolagoon_sign.d9dcca58.jpg";